import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取核销订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含订单列表的Promise对象
 */
export function listStoreOrderWriteoff(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.listStoreOrderWriteoff',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 确认核销订单
 * @param {Object} data 订单数据
 * @returns {Promise} 包含操作结果的Promise对象
 */
export function confirmWriteOffOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.confirmWriteOffOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      if (res.code !== 0) {
        reject(new Error(res.msg))
        return
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}